<script lang="ts">
  import type { Action } from "svelte/action"
  import AUButton from "component_library/components/svelte/ui/AUButton.svelte"
  import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
  import { getContext } from "svelte"
  import Svg from "website_script/components/Svg.svelte"
  import themeTokens from "conversion_flows/theme/LibUIThemeTokens"
  import AUButtonIcon from "component_library/components/svelte/ui/AUButtonIcon.svelte"
  import IntegrationTypes from "website_script/constants/IntegrationTypes"
  import type { ButtonConfig } from "website_script/types/widgets"
  import { leadFlowIcon } from "conversion_flows/types/leadFlowIcons"
  import { getFlowsContext } from "website_script/contexts/flows"

  export let buttonConfig: ButtonConfig
  export let use: Action[] = []
  export let id: string | undefined = undefined
  export let isFirst: boolean = false
  export let isLast: boolean = false

  const { triggerFlow } = getFlowsContext()
  const { text, icon, show_text: showText } = buttonConfig
  const handleClick = () =>
    triggerFlow(buttonConfig, IntegrationTypes.FLOATING_ACTION_BUTTON)

  const dealerTheme = getContext<DealerTheme>("dealerTheme")
  const tokens = themeTokens(dealerTheme)

  const positionClass =
    isFirst && isLast ? "single" : isFirst ? "first" : isLast ? "last" : ""
</script>

<div class="au-fabbutton {positionClass}">
  {#if showText === true}
    <AUButton {use} size="lg" onClick={handleClick} {id}>
      <Svg
        color={String(tokens("colors.primaryContrastForeground"))}
        alt={text}
        aria-hidden="true"
        data={leadFlowIcon(icon)}
        slot="leftIcon"
      />
      {text}
    </AUButton>
  {:else}
    <AUButtonIcon
      {id}
      {use}
      size="lg"
      color="primary"
      sroText={text}
      icon={leadFlowIcon(icon)}
      onClick={handleClick}
    />
  {/if}
</div>

<style>
  .au-fabbutton {
    --au-button-border-radius: 0;

    border-radius: 0;
    padding: var(--au-spacing-2xs);
  }

  .au-fabbutton :global(.au-button[data-size="lg"][role="button"]) {
    --au-button-gap: var(--au-spacing-xs);
  }

  .au-fabbutton:not(.first):not(.last) :global(.au-button[data-size="lg"]) {
    --au-button-padding: var(--au-spacing-sm) var(--au-spacing-xs);
  }

  .au-fabbutton:not(.last):not(.single) {
    border-right: 1px solid var(--au-button-primary-hover-border-color);
  }

  .au-fabbutton:not(.first):not(.single) {
    border-left: 1px solid var(--au-button-primary-active-border-color);
  }

  .au-fabbutton.first :global(.au-button[data-size="lg"]) {
    --au-button-border-radius: var(--au-tappable-size) 0 0
      var(--au-tappable-size);
    --au-button-padding: var(--au-spacing-sm) var(--au-spacing-xs)
      var(--au-spacing-sm) var(--au-spacing-sm);
  }

  .au-fabbutton.last :global(.au-button[data-size="lg"]) {
    --au-button-border-radius: 0 var(--au-tappable-size) var(--au-tappable-size)
      0;
    --au-button-padding: var(--au-spacing-sm) var(--au-spacing-sm)
      var(--au-spacing-sm) var(--au-spacing-xs);
  }

  .au-fabbutton.single :global(.au-button[data-size="lg"]) {
    --au-button-border-radius: var(--au-tappable-size);
  }

  .au-fabbutton :global(.au-button[data-size="lg"] .au-button__left-icon) {
    width: var(--au-spacing-lg);
  }

  .au-fabbutton.first :global(.au-button-icon[data-size="lg"]) {
    --au-button-border-radius: var(--au-tappable-size) 0 0
      var(--au-tappable-size);
  }

  .au-fabbutton.last :global(.au-button-icon[data-size="lg"]) {
    --au-button-border-radius: 0 var(--au-tappable-size) var(--au-tappable-size)
      0;
  }

  .au-fabbutton :global(.au-button-icon[data-size="lg"] svg) {
    width: var(--au-spacing-xl);
    height: var(--au-spacing-xl);
  }
</style>
